import Dot from "../../../components/dot/dot";
import { formatDate } from "../../../helpers/dateHelper";
import { NotificationListItemProps } from "./types/notificationBadgeProps";

const NotificationListItem = (props: NotificationListItemProps) => {

    const prepareDate = (_epoch?: number) => {
        if (!_epoch) return "";
        const start = Date.now();
        const elapsed = Math.abs(start - _epoch);
        if (elapsed < 30000) {
            return "teraz";
        }
        const elapsedMin = elapsed / 60000;
        if (elapsedMin < 60) {
            return `${Math.round(elapsedMin)} min temu`;
        }
        if (elapsedMin < 1440) {
            return `${Math.round(elapsedMin / 60)} h temu`;
        }
        if (elapsedMin <= 2160) {
            return "1 dzień temu";
        }
        if (elapsedMin <= 3600) {
            return "2 dni temu";
        }
        if (elapsedMin <= 5040) {
            return "3 dni temu";
        }

        return formatDate(new Date(_epoch), false);
    }

    return (
        <div className="notification-list-item">
            <Dot active={props.active} />
            <div className="body-txt-medium">{props.text}</div>
            <div></div>
            <div className="body-txt-small">{prepareDate(props.epoch)}</div>
        </div>
    )
}

export default NotificationListItem;